import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _Event;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { RESPONSE, SESSION_STARTED_OR_RESUMED_EVENT, RCE_EVENT, PAGE_BLURRED_EVENT, PAGE_FOCUSED_EVENT, QUIZ_SUBMISSION_EVENT, Flex } from '@instructure/quiz-common';
import { Table } from '@instructure/ui-table';
import ElapsedTime from '../resources/ElapsedTime';
import ResponseEvent from './ResponseEvent';
import SessionStartEvent from './SessionStartEvent';
import { SessionSubmitEvent } from './SessionSubmitEvent';
import RCEEvent from './RCEEvent';
import PageBlurredEvent from './PageBlurredEvent';
import PageFocusedEvent from './PageFocusedEvent';
import { extractSessionData } from '../resources/util/extractSessionData';
import { Text } from '@instructure/ui-text';
export var Event = /*#__PURE__*/function (_Component) {
  function Event() {
    _classCallCheck(this, Event);
    return _callSuper(this, Event, arguments);
  }
  _inherits(Event, _Component);
  return _createClass(Event, [{
    key: "renderResponseEvent",
    value: function renderResponseEvent(event, currentEventData) {
      var item = event.getItem();
      if (!item) {
        return null;
      } else {
        return /*#__PURE__*/React.createElement(ResponseEvent, {
          event: event,
          item: item,
          currentEventData: currentEventData
        });
      }
    }
  }, {
    key: "renderPayload",
    value: function renderPayload(event, eventData) {
      switch (event.eventType) {
        case RESPONSE:
          return this.renderResponseEvent(event, eventData);
        case SESSION_STARTED_OR_RESUMED_EVENT:
          return /*#__PURE__*/React.createElement(SessionStartEvent, {
            currentEventData: eventData
          });
        case QUIZ_SUBMISSION_EVENT:
          return /*#__PURE__*/React.createElement(SessionSubmitEvent, {
            currentEventData: eventData
          });
        case RCE_EVENT:
          return /*#__PURE__*/React.createElement(RCEEvent, {
            event: event,
            currentEventData: eventData
          });
        case PAGE_BLURRED_EVENT:
          return /*#__PURE__*/React.createElement(PageBlurredEvent, {
            currentEventData: eventData
          });
        case PAGE_FOCUSED_EVENT:
          return /*#__PURE__*/React.createElement(PageFocusedEvent, {
            currentEventData: eventData
          });
        default:
          return null;
        // unknown event
      }
    }
  }, {
    key: "renderEventTime",
    value: function renderEventTime(createdDate, startTime, multipleSessionAttempt) {
      var textColor = multipleSessionAttempt ? 'danger' : 'primary';
      return /*#__PURE__*/React.createElement(Text, {
        color: textColor
      }, /*#__PURE__*/React.createElement(ElapsedTime, {
        eventTime: createdDate,
        startTime: startTime
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        event = _this$props.event,
        startTime = _this$props.startTime;
      var currentEventData = extractSessionData(event);
      var payloadNode = this.renderPayload(event, currentEventData);
      if (!payloadNode) return null;
      return /*#__PURE__*/React.createElement(Table.Row, null, /*#__PURE__*/React.createElement(Table.Cell, null, /*#__PURE__*/React.createElement(Flex, {
        direction: "column"
      }, this.renderEventTime(event.createdDate(), startTime, currentEventData.multipleSessionAttempt))), /*#__PURE__*/React.createElement(Table.Cell, null, payloadNode));
    }
  }]);
}(Component);
_Event = Event;
// This ugly hack is necessary because the InstUI v7 Table.Body only renders components with name 'Row'.
_defineProperty(Event, "displayName", 'Row');
_defineProperty(Event, "componentId", "Quizzes".concat(_Event.displayName));
_defineProperty(Event, "propTypes", {
  event: ImmutablePropTypes.record,
  startTime: PropTypes.instanceOf(Date)
});
_defineProperty(Event, "defaultProps", {
  event: void 0,
  startTime: void 0
});
export default Event;